import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'comment',
	prefix: 'comment',
	key: 'comment_id',
	fields: {
		comment_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		comment_date: Model.SCHEMA_DATE,
		comment_text: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				user: this.get_user_id() || 0,
				date: this.get_date() || 0,
				text: String(this.get_text() || '').replace(/\n/g, '<br />\n')
			}
		}
	}
})
